// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1RTcF","label":"Section_label__2cYSD","contentWrap":"Section_contentWrap__3R1uA","footer":"Section_footer__1ZLy-","footerInner":"Section_footerInner__1a0Tl"};